var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdPClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 1120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .thirdP0C.fill,\n      .thirdP1C.fill,\n      .thirdP2C.fill,\n      .thirdP3C.fill,\n      .thirdP4C.fill,\n      .thirdP5C.fill,\n      .thirdP6C.fill,\n      .thirdP7C.fill,\n      .thirdP8C.fill,\n      .thirdP9C.fill,\n      .thirdP10C.fill,\n      .thirdP11C.fill{\n        fill: lightgrey;\n        transition: fill 0.5s ease-in-out;\n      }\n      .thirdP0C.show {\n        fill: #f20519;\n      }\n\n      rect{\n        fill: #fff;\n      }\n      .thirdP1C.show {\n        fill: #700;\n      }\n\n      .thirdP2C.show {\n        fill: #bf0404;\n      }\n\n      .thirdP3C.show {\n        fill: #0f2e7c;\n      }\n\n      .thirdP4C.show {\n        fill: #730202;\n      }\n\n      .thirdP5C.show {\n        fill: #027333;\n      }\n\n      .thirdP6C.show {\n        fill: #ffb600;\n      }\n\n      .thirdP7C.show {\n        fill: #fff;\n      }\n\n      .thirdP8C.show {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n\n      .thirdP9C.show {\n        fill: #ffbc00;\n      }\n\n      .thirdP10C.show {\n        fill: #da1018;\n      }\n\n      .thirdP11C.show {\n        display: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "thirdP11C"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -963.52,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -901.34,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -839.17,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -777,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -714.82,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -963.52,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -901.34,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -839.17,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -777,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -714.82,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -963.52,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -901.34,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -839.17,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -777,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -714.82,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -963.52,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -901.34,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -839.17,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -777,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -714.82,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -963.52,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -901.34,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -839.17,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -777,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -714.82,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -652.65,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -590.47,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -528.3,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -466.12,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -403.95,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -341.77,
    y: 214.86,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -652.65,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -590.47,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -528.3,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -466.12,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.95,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -652.65,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -590.47,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -528.3,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -466.12,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -403.95,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -652.65,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -590.47,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -528.3,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -466.12,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -403.95,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -652.65,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -590.47,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -528.3,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -466.12,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -403.95,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -963.52,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -901.34,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -839.17,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -777,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -714.82,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -963.52,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -901.34,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -839.17,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -777,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -714.82,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -963.52,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -901.34,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -839.17,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -777,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -714.82,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -963.52,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -901.34,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -839.17,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -777,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -963.52,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -901.34,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -839.17,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -777,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -714.82,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -652.65,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -590.47,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -528.3,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -466.12,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -403.95,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -652.65,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -590.47,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -528.3,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -466.12,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -403.95,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -652.65,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -590.47,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -528.3,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -466.12,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.95,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -652.65,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -652.65,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -652.65,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -714.82,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP10C",
    x: -590.47,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -528.3,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -466.12,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -403.95,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -590.47,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -528.3,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -466.12,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -403.95,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -341.77,
    y: 277.03,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -341.77,
    y: 339.21,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -341.77,
    y: 401.38,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -341.77,
    y: 463.56,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -341.77,
    y: 525.73,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -341.77,
    y: 587.91,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -341.77,
    y: 650.08,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -341.77,
    y: 712.26,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -341.77,
    y: 774.43,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -963.52,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -901.34,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -839.17,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -777,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -714.82,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -652.65,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -590.47,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP1C",
    x: -528.3,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP8C",
    x: -466.12,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP3C",
    x: -403.95,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP9C",
    x: -341.77,
    y: 836.61,
    width: 62.17,
    height: 62.17
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "thirdP11C"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -377.51,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-823.02 253.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.77,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-886.42 280.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -377.51,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-860.16 343.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -430.03,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-912.69 216.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -430.03,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-949.83 306.37) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.77,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-923.56 369.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -377.51,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-897.3 433.18) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -456.29,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-976.09 242.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -482.56,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1002.35 179.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -456.29,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1013.23 332.64) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -430.03,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-986.97 396.04) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.77,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-960.7 459.44) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -482.56,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1039.49 269.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -508.82,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1065.75 205.83) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -535.08,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1092.01 142.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -377.51,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-934.44 522.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -482.56,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1076.63 358.9) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -456.29,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1050.37 422.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -430.03,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1024.11 485.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -508.82,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1102.89 295.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -535.08,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1129.16 232.09) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -561.34,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1155.42 168.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -587.6,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1181.68 105.29) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -377.51,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-971.58 612.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.77,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-997.84 549.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -508.82,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1140.03 385.16) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -482.56,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1113.77 448.56) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -456.29,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1087.51 511.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -535.08,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1166.3 321.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -561.34,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1192.56 258.36) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -587.6,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1218.82 194.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -613.87,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1245.08 131.55) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -640.13,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1271.34 68.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -377.51,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1008.72 702.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -403.77,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1034.98 638.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -430.03,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1061.25 575.37) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -535.08,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1203.44 411.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -508.82,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1177.17 474.83) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -482.56,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1150.91 538.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -561.34,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1229.7 348.02) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -587.6,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1255.96 284.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -613.87,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1282.22 221.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -640.13,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1308.48 157.81) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -666.39,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1334.75 94.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -692.65,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1361.01 31.01) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -377.51,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1045.86 791.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -403.77,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1072.13 728.44) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -430.03,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1098.39 665.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -456.29,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1124.65 601.63) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -561.34,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1266.84 437.68) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -535.08,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1240.58 501.09) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -508.82,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1214.31 564.49) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -587.6,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1293.1 374.28) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -613.87,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1319.36 310.88) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -640.13,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1345.63 247.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -666.39,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1371.89 184.07) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -692.65,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1398.15 120.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -718.92,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1424.41 57.27) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -745.18,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1450.67 -6.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -403.77,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1109.27 818.1) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -377.51,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1083 881.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -430.03,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1135.53 754.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -456.29,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1161.79 691.3) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -482.56,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1188.05 627.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -587.6,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1330.24 463.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -561.34,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1303.98 527.35) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -535.08,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1277.72 590.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -613.87,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1356.5 400.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -640.13,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1382.77 337.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -666.39,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1409.03 273.74) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -692.65,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1435.29 210.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -718.92,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1461.55 146.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -745.18,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1487.81 83.53) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -771.44,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1514.08 20.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -797.7,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1540.34 -43.27) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -430.03,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1172.67 844.36) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -403.77,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1146.41 907.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -377.51,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1120.14 971.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -456.29,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1198.93 780.96) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -482.56,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1225.19 717.56) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -508.82,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1251.45 654.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -613.87,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1393.64 490.21) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -587.6,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1367.38 553.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -561.34,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1341.12 617.01) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -640.13,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1419.91 426.81) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -666.39,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1446.17 363.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -692.65,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1472.43 300) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -718.92,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1498.69 236.6) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -745.18,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1524.95 173.2) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -771.44,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1551.22 109.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -797.7,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1577.48 46.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -823.96,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1603.74 -17.01) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -850.23,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1630 -80.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -456.29,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1236.07 870.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -430.03,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1209.81 934.03) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -403.77,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1183.55 997.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -377.51,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1157.28 1060.83) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -482.56,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1262.33 807.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -508.82,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1288.6 743.82) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -535.08,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1314.86 680.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -902.75,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-2091.07 779.09) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -876.49,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-2027.67 752.83) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -850.23,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-2001.41 816.23) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -902.75,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-2053.93 689.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -850.23,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1964.27 726.57) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -823.96,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1938.01 789.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -797.7,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1911.74 853.37) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -876.49,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1990.53 663.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -902.75,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-2016.79 599.76) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -823.96,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1900.86 700.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -797.7,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1874.6 763.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -771.44,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1848.34 827.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -850.23,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1927.13 636.9) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -876.49,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1953.39 573.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -902.75,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1979.65 510.1) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -745.18,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1822.08 890.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -797.7,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1837.46 674.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -771.44,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1811.2 737.45) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -745.18,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1784.94 800.85) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -823.96,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1863.72 610.64) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -850.23,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1889.99 547.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -876.49,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1916.25 483.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -902.75,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1942.51 420.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -692.65,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1732.41 927.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -718.92,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1758.68 864.25) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -771.44,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1774.06 647.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -745.18,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1747.8 711.19) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -718.92,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1721.54 774.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -797.7,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1800.32 584.38) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -823.96,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1826.58 520.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -850.23,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1852.85 457.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -876.49,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1879.11 394.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -902.75,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1905.37 330.77) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -640.13,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1642.75 964.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -666.39,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1669.01 901.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -692.65,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1695.27 837.99) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -745.18,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1710.66 621.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -718.92,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1684.39 684.92) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -692.65,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1658.13 748.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -771.44,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1736.92 558.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -797.7,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1763.18 494.72) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -823.96,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1789.44 431.31) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -850.23,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1815.71 367.91) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -876.49,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1841.97 304.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -902.75,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1868.23 241.11) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -587.6,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1553.08 1001.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -613.87,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1579.35 938.53) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -640.13,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1605.61 875.13) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -666.39,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1631.87 811.73) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -718.92,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1647.25 595.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -692.65,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1620.99 658.66) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -666.39,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1594.73 722.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -745.18,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1673.52 531.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -771.44,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1699.78 468.45) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -797.7,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1726.04 405.05) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -823.96,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1752.3 341.65) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -850.23,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1778.57 278.25) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -876.49,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1804.83 214.84) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -902.75,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1831.09 151.44) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -561.34,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1489.68 975.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -535.08,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1463.42 1039.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -587.6,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1515.94 912.27) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -613.87,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1542.21 848.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: -640.13,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1568.47 785.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -692.65,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1583.85 569) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -666.39,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1557.59 632.4) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -640.13,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1531.33 695.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -718.92,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1610.11 505.59) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -745.18,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1636.38 442.19) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -771.44,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1662.64 378.79) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -797.7,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1688.9 315.39) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -823.96,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1715.16 251.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -850.23,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1741.43 188.58) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -876.49,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1767.69 125.18) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -902.75,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1793.95 61.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -535.08,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1426.28 949.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -508.82,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1400.02 1012.81) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -482.56,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1373.75 1076.22) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -561.34,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1452.54 886.01) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -587.6,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1478.8 822.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -613.87,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1505.07 759.2) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -666.39,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1520.45 542.73) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -640.13,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1494.19 606.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -613.87,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1467.92 669.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -692.65,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1546.71 479.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -718.92,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1572.97 415.93) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -745.18,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1599.24 352.53) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -771.44,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1625.5 289.12) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -797.7,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1651.76 225.72) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -823.96,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1678.02 162.32) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -850.23,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1704.28 98.92) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -876.49,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1730.55 35.51) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -902.75,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1756.81 -27.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -508.82,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1362.88 923.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -482.56,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1336.61 986.55) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -456.29,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1310.35 1049.95) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -430.03,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1284.09 1113.36) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -535.08,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1389.14 859.75) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -561.34,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1415.4 796.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -587.6,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1441.66 732.94) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -640.13,
    y: 541.43,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1457.05 516.47) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -613.87,
    y: 567.69,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1430.78 579.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -587.6,
    y: 593.95,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1404.52 643.28) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: -666.39,
    y: 515.17,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1483.31 453.07) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -692.65,
    y: 488.91,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1509.57 389.67) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -718.92,
    y: 462.64,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1535.83 326.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -745.18,
    y: 436.38,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1562.1 262.86) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -771.44,
    y: 410.12,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1588.36 199.46) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -797.7,
    y: 383.86,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1614.62 136.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -823.96,
    y: 357.59,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1640.88 72.65) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -850.23,
    y: 331.33,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1667.14 9.25) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -876.49,
    y: 305.07,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1693.41 -54.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -902.75,
    y: 278.81,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1719.67 -117.55) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: -482.56,
    y: 699,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1299.47 896.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -456.29,
    y: 725.27,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1273.21 960.29) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -430.03,
    y: 751.53,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1246.95 1023.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -403.77,
    y: 777.79,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1220.69 1087.09) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -377.51,
    y: 804.05,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1194.42 1150.5) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: -508.82,
    y: 672.74,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1325.74 833.48) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: -535.08,
    y: 646.48,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1352 770.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: -561.34,
    y: 620.22,
    width: 37.14,
    height: 37.14,
    transform: "translate(-1378.26 706.68) rotate(-135)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(-10.54 25.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-21.09 50.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(-46.54 40.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 58.37,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(4.37 61.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(-31.63 76.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-57.09 65.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-82.54 55.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 83.82,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(-6.18 86.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 109.28,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(19.28 97.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-42.18 101.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-67.63 91.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-93.09 80.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 109.28,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(-16.72 112.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 134.74,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(8.74 122.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(34.19 133.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-118.54 70.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 109.28,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-52.72 127.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-78.18 116.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-103.63 106.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 134.74,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-27.27 137.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 160.19,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(-1.81 148.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 185.65,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(23.65 158.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 211.1,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(49.1 169.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-154.55 85.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-129.09 95.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 134.74,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-63.27 152.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 109.28,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-88.72 142.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-114.18 131.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 160.19,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-37.81 163.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 185.65,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(-12.35 173.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 211.1,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(13.1 184.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 236.56,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(38.56 194.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(64.01 205.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-190.55 100.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-165.09 110.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-139.63 121.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-73.81 178.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 134.74,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-99.27 167.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 109.28,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-124.72 157.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 185.65,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-48.35 188.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 211.1,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-22.9 199.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 236.56,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(2.56 209.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(28.01 220.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(53.47 230.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(78.93 241.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-226.55 114.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 32.91,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-201.09 125.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 58.37,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-175.63 136.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 83.82,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-150.18 146.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 185.65,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-84.35 203.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-109.81 193.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 134.74,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-135.27 182.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 211.1,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-58.9 214.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 236.56,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-33.44 224.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(-7.99 235.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(17.47 245.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(42.93 256.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(68.38 266.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(93.84 277.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-237.09 140.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-262.55 129.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-211.63 150.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 83.82,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-186.18 161.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 109.28,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-160.72 172.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 211.1,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-94.9 229.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-120.35 218.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-145.81 208.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 236.56,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-69.44 239.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-43.99 250.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-18.53 260.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(6.93 271.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(32.38 281.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(57.84 292.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 389.3,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(83.29 302.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(108.75 313.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-247.63 165.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-273.09 155.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-298.55 144.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 83.82,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-222.18 176.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-196.72 186.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 134.74,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-171.27 197.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-105.44 254.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 211.1,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-130.9 244.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-156.35 233.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 262.02,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-79.99 265.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 287.47,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-54.53 275.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-29.07 286.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(-3.62 296.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(21.84 307.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 389.3,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(47.29 317.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(72.75 328.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 440.21,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(98.21 338.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(123.66 349.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-258.18 191.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-283.63 180.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-309.09 170.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-334.55 159.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-232.72 201.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 134.74,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-207.27 212.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-181.81 222.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-221.43 534.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-210.88 509.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 465.66,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-236.34 498.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-185.43 519.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-200.34 483.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 440.21,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-225.8 473.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 414.75,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-251.25 462.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-174.88 494.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-149.43 504.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-189.8 458.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 414.75,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-215.25 447.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 389.3,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-240.71 437.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-164.34 468.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-138.88 479.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-113.43 489.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-266.16 426.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 414.75,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-179.25 432.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 389.3,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-204.71 422.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 363.84,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-230.16 411.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-153.8 443.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-128.34 453.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-102.88 464.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-77.43 474.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 312.93,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-281.08 390.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 338.38,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-255.62 401.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 389.3,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-168.71 407.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 363.84,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-194.16 396.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 338.38,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-219.62 386.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 414.75,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-143.25 417.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-117.8 428.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-92.34 438.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-66.88 449.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-41.43 460.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-295.99 354.58) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 287.47,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-270.53 365.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 312.93,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-245.08 375.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-158.16 381.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 338.38,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-183.62 371.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 312.93,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-209.08 360.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 389.3,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-132.71 392.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 414.75,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-107.25 402.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 440.21,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-81.8 413.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 465.66,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-56.34 424.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 491.12,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-30.88 434.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-5.43 445.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-310.9 318.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-285.44 329.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-259.99 339.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 287.47,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-234.53 350.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 338.38,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-147.62 356.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 312.93,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-173.08 345.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 287.47,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-198.53 335.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-122.16 366.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 389.3,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-96.71 377.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 414.75,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-71.25 388.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 440.21,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-45.8 398.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-20.34 409.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(5.12 419.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(30.57 430.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-300.36 293.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-325.81 282.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-274.9 303.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-249.44 314.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-223.99 324.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 312.93,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-137.07 330.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 287.47,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-162.53 320.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-187.99 309.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-111.62 341.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-86.16 352.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 389.3,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-60.71 362.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-35.25 373.11) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 440.21,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-9.79 383.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(15.66 394.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(41.12 404.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(66.57 415.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-289.81 267.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 134.74,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-315.27 257.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-340.72 246.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-264.35 278.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-238.9 288.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-213.44 299.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-126.53 305.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 262.02,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-151.99 294.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 236.56,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-177.44 284.38) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 312.93,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-101.07 316.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-75.62 326.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-50.16 337.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 389.3,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-24.71 347.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(.75 358.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(26.21 368.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(51.66 379.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(77.12 389.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(102.57 400.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 134.74,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-279.27 242.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-304.72 231.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 83.82,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-330.18 221.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-355.63 210.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-253.81 252.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-228.35 263.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-202.9 273.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 262.02,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(-115.99 280.02) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(-141.44 269.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(-166.9 258.93) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(-90.53 290.56) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(-65.07 301.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(-39.62 311.65) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(-14.16 322.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 389.3,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(11.29 332.74) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 414.75,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(36.75 343.28) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(62.21 353.83) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(87.66 364.37) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(113.12 374.91) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(138.57 385.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 109.28,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(-268.72 216.75) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(-294.18 206.21) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(-319.63 195.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(-345.09 185.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(-370.55 174.57) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 134.74,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(-243.27 227.3) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(-217.81 237.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(-192.35 248.38) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1850.5 817.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1789.05 842.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1814.5 904.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1025.63,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1763.59 781.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1727.59 868.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1753.05 929.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1778.5 991.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1000.18,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1702.13 806.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 974.72,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1676.68 745.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1666.13 893.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1691.59 955.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1717.05 1016.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 974.72,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1640.68 832.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 949.26,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1615.22 770.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1589.77 709.42) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1742.5 1078.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 974.72,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1604.68 919.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1630.13 980.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1655.59 1042.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 949.26,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1579.22 857.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 923.81,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1553.77 796.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 898.35,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1528.31 734.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 872.9,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1502.85 673.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1706.5 1165.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1681.05 1103.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 949.26,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1543.22 944.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 974.72,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1568.68 1006.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1594.13 1067.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 923.81,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1517.77 883.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 898.35,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1492.31 821.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 872.9,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1466.85 760.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 847.44,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1441.4 698.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1415.94 637.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1670.5 1251.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1645.05 1190.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1619.59 1129.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1481.77 970.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 949.26,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1507.22 1031.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 974.72,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1532.68 1093.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 898.35,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1456.31 908.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 872.9,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1430.85 847.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 847.44,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1405.4 785.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1379.94 724.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1354.49 662.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1329.03 601.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1634.5 1338.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1051.09,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1609.05 1277.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1025.63,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1583.59 1215.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1000.18,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1558.13 1154.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 898.35,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1420.31 995.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1445.77 1057.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 949.26,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1471.22 1118.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 872.9,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1394.85 934.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 847.44,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1369.4 872.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1343.94 811.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1318.49 749.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1293.03 688.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1267.57 626.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1242.12 565.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1573.05 1364.35) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1598.5 1425.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1547.59 1302.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1000.18,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1522.13 1241.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 974.72,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1496.68 1179.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 872.9,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1358.85 1021.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1384.31 1082.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1409.77 1143.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 847.44,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1333.4 959.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1307.94 898.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1282.49 836.7) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1257.03 775.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1231.57 713.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1206.12 652.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 694.7,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1180.66 590.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1155.21 529.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1511.59 1389.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1537.05 1451.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1562.5 1512.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1000.18,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1486.13 1328.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1460.68 1266.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 949.26,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1435.22 1205.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1297.4 1046.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 872.9,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1322.85 1107.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1348.31 1169.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 821.98,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1271.94 985.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 796.53,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1246.48 923.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1221.03 862.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1195.57 800.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1170.12 739.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 694.7,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1144.66 677.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1119.2 616.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 643.79,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1093.75 554.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(1068.29 493.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1450.13 1415.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1475.59 1476.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(1501.04 1538.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1526.5 1599.63) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1424.68 1353.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 949.26,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1399.22 1292.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1373.76 1230.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(621.38 1326.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(682.83 1301.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 618.34,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(708.29 1362.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(657.38 1239.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(744.29 1275.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 643.79,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(769.75 1337.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 669.25,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(795.2 1398.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(718.83 1214.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(693.38 1152.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(805.75 1250.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 669.25,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(831.2 1311.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 694.7,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(856.66 1373.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(780.29 1188.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(754.84 1127.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(729.38 1065.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(882.12 1434.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 669.25,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(867.2 1224.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 694.7,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(892.66 1286.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 720.16,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(918.12 1347.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(841.75 1163.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(816.29 1101.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(790.84 1040.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(765.38 978.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 771.07,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(969.03 1470.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 745.62,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(943.57 1409.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 694.7,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(928.66 1199.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 720.16,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(954.12 1260.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 745.62,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(979.57 1322.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 669.25,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(903.2 1137.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(877.75 1076.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(852.29 1014.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(826.84 953.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(801.38 891.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(1055.94 1506.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 796.53,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(1030.48 1445.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 771.07,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1005.03 1383.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(990.12 1173.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 745.62,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1015.57 1235.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 771.07,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1041.03 1296.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 694.7,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(964.66 1112.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 669.25,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(939.2 1050.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 643.79,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(913.75 989.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 618.34,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(888.29 927.97) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 592.88,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(862.84 866.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(837.38 805.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(1142.85 1542.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(1117.4 1481.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1091.94 1419.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 796.53,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(1066.48 1358.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 745.62,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1051.57 1148.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 771.07,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1077.03 1209.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 796.53,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1102.48 1271.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1026.12 1086.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 694.7,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1000.66 1025.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 669.25,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(975.2 963.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 643.79,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(949.75 902.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(924.29 841.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(898.84 779.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(873.38 718.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(1204.31 1517.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(1229.76 1578.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1178.85 1455.62) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(1153.4 1394.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1127.94 1332.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 771.07,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1113.03 1122.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 796.53,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1138.48 1184.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1163.94 1245.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1087.57 1061.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1062.12 999.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 694.7,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1036.66 938.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1011.2 877.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 643.79,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(985.75 815.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(960.29 754.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(934.84 692.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(909.38 631.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1265.76 1491.63) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 949.26,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(1291.22 1553.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(1316.68 1614.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(1240.31 1430.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1214.85 1368.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1189.4 1307.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1174.48 1097.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 821.98,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1199.94 1158.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 847.44,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1225.4 1220.34) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 771.07,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1149.03 1035.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1123.57 974.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1098.12 913.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 694.7,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1072.66 851.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1047.2 790.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1021.75 728.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(996.29 667.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(970.84 605.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(945.38 544.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 949.26,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(1327.22 1466.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1352.68 1527.63) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1000.18,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(1378.13 1589.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(1403.59 1650.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1301.76 1404.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1276.31 1343.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1250.85 1281.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 821.98,
    y: 262.02,
    width: 36,
    height: 36,
    transform: "translate(1235.94 1071.98) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 287.47,
    width: 36,
    height: 36,
    transform: "translate(1261.4 1133.43) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 312.93,
    width: 36,
    height: 36,
    transform: "translate(1286.85 1194.89) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 236.56,
    width: 36,
    height: 36,
    transform: "translate(1210.48 1010.52) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 211.1,
    width: 36,
    height: 36,
    transform: "translate(1185.03 949.06) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 185.65,
    width: 36,
    height: 36,
    transform: "translate(1159.57 887.61) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 160.19,
    width: 36,
    height: 36,
    transform: "translate(1134.12 826.15) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 694.7,
    y: 134.74,
    width: 36,
    height: 36,
    transform: "translate(1108.66 764.69) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 669.25,
    y: 109.28,
    width: 36,
    height: 36,
    transform: "translate(1083.2 703.24) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 83.82,
    width: 36,
    height: 36,
    transform: "translate(1057.75 641.78) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 58.37,
    width: 36,
    height: 36,
    transform: "translate(1032.29 580.33) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 32.91,
    width: 36,
    height: 36,
    transform: "translate(1006.84 518.87) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 7.46,
    width: 36,
    height: 36,
    transform: "translate(981.38 457.41) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 974.72,
    y: 414.75,
    width: 36,
    height: 36,
    transform: "translate(1388.68 1440.71) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 440.21,
    width: 36,
    height: 36,
    transform: "translate(1414.13 1502.17) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 465.66,
    width: 36,
    height: 36,
    transform: "translate(1439.59 1563.63) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 491.12,
    width: 36,
    height: 36,
    transform: "translate(1465.04 1625.08) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 516.58,
    width: 36,
    height: 36,
    transform: "translate(1490.5 1686.54) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 949.26,
    y: 389.3,
    width: 36,
    height: 36,
    transform: "translate(1363.22 1379.26) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 363.84,
    width: 36,
    height: 36,
    transform: "translate(1337.76 1317.8) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 338.38,
    width: 36,
    height: 36,
    transform: "translate(1312.31 1256.34) rotate(-135)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(781.29 302.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(770.75 277.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(745.29 287.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 58.37,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(796.2 266.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(760.2 251.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(734.75 262.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(709.29 272.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 83.82,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(785.66 241.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 109.28,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(811.11 230.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(749.66 226.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(724.2 236.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(698.74 247.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 109.28,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(775.11 215.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 134.74,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(800.57 205.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(826.02 194.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(673.29 257.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 109.28,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(739.11 200.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(713.66 211.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(688.2 221.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 134.74,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(764.57 190.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 160.19,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(790.02 179.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 185.65,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(815.48 169.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 211.1,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(840.94 158.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(637.29 242.89) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(662.74 232.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 134.74,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(728.57 175.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 109.28,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(703.11 185.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(677.66 196.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 160.19,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(754.02 164.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 185.65,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(779.48 154.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 211.1,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(804.94 143.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 236.56,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(830.39 133.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(855.85 122.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 7.46,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(601.29 227.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 32.91,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(626.74 217.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 58.37,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(652.2 206.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(718.02 149.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 134.74,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(692.57 160.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 109.28,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(667.11 170.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 185.65,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(743.48 139.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 211.1,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(768.94 128.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 236.56,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(794.39 118.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(819.85 107.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(845.3 97.08) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(870.76 86.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(565.29 213.06) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 32.91,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(590.74 202.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 58.37,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(616.2 191.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 83.82,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(641.66 181.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 185.65,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(707.48 124.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(682.02 134.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 134.74,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(656.57 145.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 211.1,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(732.94 113.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 236.56,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(758.39 103.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(783.85 92.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(809.3 82.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(834.76 71.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(860.22 61.07) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(885.67 50.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(554.74 187.61) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(529.29 198.15) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(580.2 177.06) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 83.82,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(605.66 166.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 109.28,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(631.11 155.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 211.1,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(696.94 98.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(671.48 109.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 160.19,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(646.02 119.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 236.56,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(722.39 88.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(747.85 77.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(773.3 67.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(798.76 56.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(824.22 46.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(849.67 35.62) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 389.3,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(875.13 25.07) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(900.58 14.53) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(544.2 162.15) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(518.74 172.69) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(493.29 183.24) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 83.82,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(569.66 151.61) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(595.11 141.06) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 134.74,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(620.57 130.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(686.39 73.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 211.1,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(660.94 83.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(635.48 94.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 262.02,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(711.85 62.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 287.47,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(737.3 52.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(762.76 41.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(788.22 31.25) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(813.67 20.71) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 389.3,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(839.13 10.16) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(864.58 -.38) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 440.21,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(890.04 -10.93) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(915.5 -21.47) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(533.66 136.69) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(508.2 147.24) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(482.74 157.78) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(457.29 168.33) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(559.11 126.15) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 134.74,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(584.57 115.61) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(610.02 105.06) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(570.4 -206.59) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(580.95 -181.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 465.66,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(555.49 -170.59) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(606.41 -191.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(591.49 -155.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 440.21,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(566.04 -145.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 414.75,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(540.58 -134.59) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(616.95 -166.22) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(642.41 -176.76) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(602.04 -130.22) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 414.75,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(576.58 -119.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 389.3,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(551.13 -109.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(627.49 -140.76) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(652.95 -151.31) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(678.41 -161.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(525.67 -98.59) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 414.75,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(612.58 -104.76) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 389.3,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(587.13 -94.22) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 363.84,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(561.67 -83.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(638.04 -115.31) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(663.49 -125.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(688.95 -136.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(714.41 -146.94) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 312.93,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(510.76 -62.59) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 338.38,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(536.21 -73.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 389.3,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(623.13 -79.31) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 363.84,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(597.67 -68.76) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 338.38,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(572.21 -58.22) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 414.75,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(648.58 -89.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(674.04 -100.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 465.66,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(699.49 -110.94) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 491.12,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(724.95 -121.48) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 516.58,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(750.41 -132.03) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(495.85 -26.59) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 287.47,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(521.3 -37.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 312.93,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(546.76 -47.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(633.67 -53.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 338.38,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(608.21 -43.31) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 312.93,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(582.76 -32.76) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 389.3,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(659.13 -64.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 414.75,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(684.58 -74.94) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 440.21,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(710.04 -85.48) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 465.66,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(735.49 -96.03) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 491.12,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(760.95 -106.57) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(786.41 -117.12) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(480.93 9.41) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(506.39 -1.13) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(531.85 -11.68) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 287.47,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(557.3 -22.22) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 338.38,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(644.21 -28.4) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 312.93,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(618.76 -17.85) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 287.47,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(593.3 -7.31) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(669.67 -38.94) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 389.3,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(695.13 -49.48) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 414.75,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(720.58 -60.03) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 440.21,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(746.04 -70.57) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(771.49 -81.12) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(796.95 -91.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(822.41 -102.21) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(491.48 34.87) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(466.02 45.41) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(516.93 24.33) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(542.39 13.78) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 262.02,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(567.85 3.24) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 312.93,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(654.76 -2.94) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 287.47,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(629.3 7.6) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 262.02,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(603.85 18.15) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(680.21 -13.48) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 363.84,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(705.67 -24.03) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 389.3,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(731.13 -34.57) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(756.58 -45.12) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 440.21,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(782.04 -55.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(807.49 -66.21) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(832.95 -76.75) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(858.41 -87.29) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(502.02 60.33) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 134.74,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(476.57 70.87) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(451.11 81.41) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(527.48 49.78) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(552.93 39.24) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(578.39 28.69) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(665.3 22.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 262.02,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(639.85 33.06) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 236.56,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(614.39 43.6) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 312.93,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(690.76 11.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(716.21 1.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(741.67 -9.12) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 389.3,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(767.13 -19.66) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 414.75,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(792.58 -30.21) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(818.04 -40.75) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(843.49 -51.29) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(868.95 -61.84) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(894.41 -72.38) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 134.74,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(512.57 85.78) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 109.28,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(487.11 96.33) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 83.82,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(461.65 106.87) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(436.2 117.41) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(538.02 75.24) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(563.48 64.69) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(588.93 54.15) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 262.02,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(675.85 47.97) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 236.56,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(650.39 58.52) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 211.1,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(624.94 69.06) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 287.47,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(701.3 37.43) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 312.93,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(726.76 26.88) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 338.38,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(752.22 16.34) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 363.84,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(777.67 5.8) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 389.3,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(803.13 -4.75) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 414.75,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(828.58 -15.29) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 440.21,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(854.04 -25.84) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 465.66,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(879.5 -36.38) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 491.12,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(904.95 -46.93) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 516.58,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(930.41 -57.47) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 109.28,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(523.11 111.24) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 83.82,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(497.66 121.78) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 58.37,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(472.2 132.33) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 32.91,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(446.74 142.87) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 7.46,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(421.29 153.41) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 134.74,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(548.57 100.69) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 160.19,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(574.02 90.15) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 185.65,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(599.48 79.6) rotate(45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2642.34 1094.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2580.88 1068.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2606.34 1007.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1025.63,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2555.42 1130.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2519.42 1043.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2544.88 981.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2570.34 920.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1000.18,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2493.97 1104.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 974.72,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2468.51 1166.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2457.97 1017.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2483.42 956.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(2508.88 894.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 974.72,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2432.51 1079.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 949.26,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2407.06 1140.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2381.6 1202.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2534.34 833.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 974.72,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2396.51 992.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(2421.97 930.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2447.42 869.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 949.26,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2371.06 1053.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 923.81,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2345.6 1115.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 898.35,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2320.14 1176.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 872.9,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2294.69 1238.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(2498.34 746.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(2472.88 808.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 949.26,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(2335.06 966.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 974.72,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2360.51 905.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(2385.97 844.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 923.81,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2309.6 1028.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 898.35,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2284.14 1089.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 872.9,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2258.69 1151.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 847.44,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2233.23 1212.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2207.78 1274.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1076.54,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(2462.34 659.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1051.09,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(2436.88 721.13) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 1025.63,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(2411.42 782.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2273.6 941.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 949.26,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(2299.06 880.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 974.72,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(2324.51 818.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 898.35,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(2248.14 1002.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 872.9,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2222.69 1064.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 847.44,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2197.23 1125.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2171.78 1187.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2146.32 1248.78) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2120.86 1310.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(2426.34 572.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1051.09,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(2400.88 634.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1025.63,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(2375.42 695.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 1000.18,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(2349.97 757.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 898.35,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(2212.14 916.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(2237.6 854.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 949.26,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(2263.06 793.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 872.9,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2186.69 977.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 847.44,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(2161.23 1038.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2135.78 1100.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2110.32 1161.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(2084.86 1223.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(2059.41 1284.79) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(2033.95 1346.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(2364.88 547.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(2390.34 485.85) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(2339.42 608.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 1000.18,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(2313.97 670.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 974.72,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(2288.51 731.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 872.9,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(2150.69 890.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(2176.14 829.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 923.81,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(2201.6 767.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 847.44,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(2125.23 952.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2099.77 1013.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(2074.32 1074.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(2048.86 1136.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(2023.41 1197.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(1997.95 1259.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 694.7,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(1972.49 1320.79) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(1947.04 1382.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(2303.42 521.85) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(2328.88 460.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(2354.33 398.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1000.18,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(2277.97 583.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(2252.51 644.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 949.26,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(2227.05 706.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(2089.23 865.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 872.9,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(2114.69 803.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(2140.14 742.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 821.98,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(2063.77 926.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 796.53,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(2038.32 988.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(2012.86 1049.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(1987.41 1110.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(1961.95 1172.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 694.7,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(1936.49 1233.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(1911.04 1295.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 643.79,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(1885.58 1356.79) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(1860.13 1418.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(2241.97 496.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(2267.42 434.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(2292.88 373.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(2318.33 312.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(2216.51 557.85) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 949.26,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(2191.05 619.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(2165.6 680.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1413.21 585.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1474.67 610.58) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 618.34,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1500.12 549.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1449.21 672.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1536.12 636.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 643.79,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1561.58 574.58) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 669.25,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1587.04 513.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(1510.67 697.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(1485.21 758.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(1597.58 661.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 669.25,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1623.04 600.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 694.7,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1648.49 538.58) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(1572.12 722.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(1546.67 784.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(1521.21 845.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1673.95 477.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 669.25,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(1659.04 686.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 694.7,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(1684.49 625.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 720.16,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1709.95 564.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(1633.58 748.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(1608.12 809.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(1582.67 871.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(1557.21 932.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 771.07,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1760.86 441.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 745.62,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1735.4 502.58) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 694.7,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(1720.49 712.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 720.16,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(1745.95 650.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 745.62,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(1771.41 589.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 669.25,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(1695.04 773.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(1669.58 835.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 618.34,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(1644.13 896.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 592.88,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(1618.67 958.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 567.42,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(1593.21 1019.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1847.77 405.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 796.53,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1822.32 466.58) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 771.07,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1796.86 528.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(1781.95 737.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 745.62,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(1807.41 676.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 771.07,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(1832.86 614.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 694.7,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(1756.49 799.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 669.25,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(1731.04 860.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 643.79,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(1705.58 922.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 618.34,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(1680.13 983.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 592.88,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(1654.67 1045.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(1629.21 1106.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(1934.69 369.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1909.23 430.57) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1883.77 492.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 796.53,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(1858.32 553.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 745.62,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(1843.41 763.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 771.07,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(1868.86 701.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 796.53,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(1894.32 640.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(1817.95 824.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 694.7,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(1792.49 886.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 669.25,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(1767.04 947.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 643.79,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(1741.58 1009.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(1716.13 1070.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(1690.67 1132.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(1665.21 1193.51) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(1996.14 394.57) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(2021.6 333.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(1970.69 456.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(1945.23 517.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP7C",
    x: 821.98,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(1919.77 578.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 771.07,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(1904.86 788.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 796.53,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(1930.32 727.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 821.98,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(1955.77 665.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(1879.41 850.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 720.16,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(1853.95 911.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 694.7,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(1828.49 973.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(1803.04 1034.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 643.79,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(1777.58 1096.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(1752.13 1157.51) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(1726.67 1218.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(1701.21 1280.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(2057.6 420.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 949.26,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(2083.05 358.57) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(2108.51 297.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(2032.14 481.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(2006.69 542.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(1981.23 604.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(1966.32 814.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 821.98,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(1991.77 752.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 847.44,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(2017.23 691.31) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 771.07,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(1940.86 875.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(1915.41 937.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(1889.95 998.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 694.7,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(1864.49 1060.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 669.25,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(1839.04 1121.51) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(1813.58 1182.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(1788.13 1244.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(1762.67 1305.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(1737.21 1367.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 949.26,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(2119.05 445.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 974.72,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(2144.51 384.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1000.18,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(2169.97 322.57) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(2195.42 261.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(2093.6 506.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(2068.14 568.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(2042.69 629.86) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 821.98,
    y: 821.81,
    width: 36,
    height: 36,
    transform: "translate(2027.77 839.68) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 847.44,
    y: 796.35,
    width: 36,
    height: 36,
    transform: "translate(2053.23 778.22) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 872.9,
    y: 770.89,
    width: 36,
    height: 36,
    transform: "translate(2078.69 716.77) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP5C",
    x: 796.53,
    y: 847.26,
    width: 36,
    height: 36,
    transform: "translate(2002.32 901.14) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 771.07,
    y: 872.72,
    width: 36,
    height: 36,
    transform: "translate(1976.86 962.59) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 745.62,
    y: 898.17,
    width: 36,
    height: 36,
    transform: "translate(1951.41 1024.05) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 720.16,
    y: 923.63,
    width: 36,
    height: 36,
    transform: "translate(1925.95 1085.5) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 694.7,
    y: 949.09,
    width: 36,
    height: 36,
    transform: "translate(1900.49 1146.96) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 669.25,
    y: 974.54,
    width: 36,
    height: 36,
    transform: "translate(1875.04 1208.42) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 643.79,
    y: 1000,
    width: 36,
    height: 36,
    transform: "translate(1849.58 1269.87) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 618.34,
    y: 1025.45,
    width: 36,
    height: 36,
    transform: "translate(1824.13 1331.33) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 592.88,
    y: 1050.91,
    width: 36,
    height: 36,
    transform: "translate(1798.67 1392.79) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 567.42,
    y: 1076.37,
    width: 36,
    height: 36,
    transform: "translate(1773.21 1454.24) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP6C",
    x: 974.72,
    y: 669.07,
    width: 36,
    height: 36,
    transform: "translate(2180.51 470.94) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 1000.18,
    y: 643.61,
    width: 36,
    height: 36,
    transform: "translate(2205.97 409.49) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1025.63,
    y: 618.16,
    width: 36,
    height: 36,
    transform: "translate(2231.42 348.03) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 1051.09,
    y: 592.7,
    width: 36,
    height: 36,
    transform: "translate(2256.88 286.57) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 1076.54,
    y: 567.25,
    width: 36,
    height: 36,
    transform: "translate(2282.33 225.12) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP0C",
    x: 949.26,
    y: 694.53,
    width: 36,
    height: 36,
    transform: "translate(2155.05 532.4) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP2C",
    x: 923.81,
    y: 719.98,
    width: 36,
    height: 36,
    transform: "translate(2129.6 593.85) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    className: "thirdP4C",
    x: 898.35,
    y: 745.44,
    width: 36,
    height: 36,
    transform: "translate(2104.14 655.31) rotate(135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdPClear);
export default __webpack_public_path__ + "static/media/ThirdP_Clear.064be9bfce59e1840e7cf69a9431b34e.svg";
export { ForwardRef as ReactComponent };